import { WorkerBridgeWorker } from './WorkerBridgeWorker';
import type { WorkerMessage } from './messages';

export function isWorkerAvailable(): boolean {
  return typeof Worker !== 'undefined';
}

export class InlineWorker {
  onmessage: ((e: MessageEvent) => void) | null = null;
  onerror: ((e: ErrorEvent) => void) | null = null;

  private _bridge: WorkerBridgeWorker;
  private _terminated: boolean = false;

  constructor() {
    const scope = {
      postMessage: (msg: unknown) => {
        if (this._terminated) return;
        if (this.onmessage) {
          this.onmessage(new MessageEvent('message', { data: msg }));
        }
      },
    };

    this._bridge = new WorkerBridgeWorker(scope);
  }

  postMessage(message: unknown): void {
    if (this._terminated) return;
    try {
      const event = new MessageEvent('message', { data: message });
      this._bridge.onMessage(event as MessageEvent<WorkerMessage>);
    } catch (err) {
      if (this.onerror) {
        this.onerror({ message: err instanceof Error ? err.message : String(err) } as ErrorEvent);
      }
    }
  }

  terminate(): void {
    this._terminated = true;
  }
}
